module.exports = __webpack_public_path__ + "img/talk-bg.61ebf8e0.jpg";